export const normalizeNumber = (value: unknown): number | null => {
    if (typeof value === 'number') return value;
    if (typeof value !== 'string' || !value.trim()) return null;

    let sanitized = value.trim();

    const indexComma = sanitized.lastIndexOf(',');
    const indexDot = sanitized.lastIndexOf('.');

    if (indexComma === -1 && indexDot === -1) {
        // "1234" → plain integer
        // nothing to clean
    } else if (indexComma === -1) {
        // "1234.56" → decimal with dot
        // nothing to clean
    } else if (indexDot === -1) {
        // "1234,56" → decimal with comma
        sanitized = sanitized.replace(',', '.');
    } else if (indexComma < indexDot) {
        // "1,234.56" → comma as thousands separator
        sanitized = sanitized.replace(/,/g, '');
    } else {
        // "1.234,56" → dot as thousands separator, comma as decimal
        sanitized = sanitized.replace(/\./g, '').replace(',', '.');
    }

    const result = parseFloat(sanitized);
    return Number.isNaN(result) ? null : result;
};
